import { render, staticRenderFns } from "./KeyTicketPills.vue?vue&type=template&id=b99ca9a2&scoped=true"
import script from "./KeyTicketPills.vue?vue&type=script&lang=js"
export * from "./KeyTicketPills.vue?vue&type=script&lang=js"
import style0 from "./KeyTicketPills.vue?vue&type=style&index=0&id=b99ca9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99ca9a2",
  null
  
)

export default component.exports